// One-click add for the wrench upsell in the cart drawer (snippets/pail-wrench-upsell.liquid).
// Delegated listener, because the drawer HTML is replaced on every cart change.
document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-pail-wrench-add]');
  if (!button || button.getAttribute('aria-disabled') === 'true') return;
  event.preventDefault();

  const cart = document.querySelector('cart-drawer');
  const error = button.closest('.pail-wrench-upsell').querySelector('.pail-wrench-upsell__error');
  const variantId = button.dataset.pailWrenchAdd;

  button.setAttribute('aria-disabled', true);
  button.classList.add('loading');
  error.hidden = true;

  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];

  const formData = new FormData();
  formData.append('id', variantId);
  formData.append('quantity', 1);
  if (cart) {
    formData.append(
      'sections',
      cart.getSectionsToRender().map((section) => section.id)
    );
    formData.append('sections_url', window.location.pathname);
  }
  config.body = formData;

  fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        error.textContent = response.description || response.message;
        error.hidden = false;
        return;
      }
      if (!cart) {
        window.location = window.routes.cart_url;
        return;
      }
      if (typeof publish === 'function') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'pail-wrench-upsell',
          productVariantId: variantId,
          cartData: response,
        });
      }
      cart.renderContents(response);
    })
    .catch((e) => {
      console.error(e);
      error.textContent = window.cartStrings ? window.cartStrings.error : 'Could not add the wrench. Please try again.';
      error.hidden = false;
    })
    .finally(() => {
      button.removeAttribute('aria-disabled');
      button.classList.remove('loading');
    });
});
